export enum HomeComponent {
  LOQ_OVERVIEW = "LoqOverview",
  ORGANIZATION_OVERVIEW = "OrganizationOverview"
}
